import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import authService from './authService';
import './css/LoginRegForm.css';
import logo from './images/logo1.png';

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [messages, setMessages] = useState('');
    const [activeTab, setActiveTab] = useState('login');
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isEmailNotVerified, setIsEmailNotVerified] = useState(false);
    const [isAccountLocked, setIsAccountLocked] = useState(false);
    const [lockoutSeconds, setLockoutSeconds] = useState(0);

    // Check for messages passed via navigation state
    useEffect(() => {
        if (location.state && location.state.message) {
            setMessages(location.state.message);
            
            if (location.state.messageType === 'success') {
                setSuccess(true);
                setError(false);
            } else {
                setError(true);
                setSuccess(false);
            }
            
            // Clear the message after a few seconds
            const timer = setTimeout(() => {
                setMessages('');
                setSuccess(false);
                setError(false);
                // Clean up the navigation state
                window.history.replaceState({}, document.title);
            }, 5000);
            
            return () => clearTimeout(timer);
        }
    }, [location]);

    const handleLogin = (e) => {
        e.preventDefault();
        authService.login(email, password).then(
            () => {
                navigate('/home');
            },
            error => {
                console.error('Login error:', error);
                setError(true);
                
                if (error.code === 'email_not_verified') {
                    setMessages('Please verify your email before logging in.');
                    setIsEmailNotVerified(true);
                } else if (error.code === 'ACCOUNT_LOCKED') {
                    const minutes = Math.round(error.lockoutSeconds / 60);
                    setMessages(`Account locked. Try again in ${minutes} min.`);
                    setIsAccountLocked(true);
                    setLockoutSeconds(error.lockoutSeconds);
                } else if (error.code === 'INVALID_CREDENTIALS') {
                    setMessages('Incorrect email or password. Please try again.');
                } else {
                    setMessages('An error occurred during login.');
                }
            }
        );
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
      };


    return (
        <div className='logreg-back'>
            <div className="box-con">
                <div className="box">
                    <div className="upper-part">
                        <img className="logo" src={logo} alt="logo" />
                    </div>
                    <div className="tab-container">
                        <Link
                            id="login-link"
                            to="/login"
                            className={`tab ${activeTab === 'login' ? 'left-tab' : ''}`}
                            onClick={() => handleTabClick('login')}>
                            Log in
                        </Link>
                        <Link
                            to="/register"
                            className={`tab ${activeTab === 'register' ? '' : 'right-disp inactive-tab'}`}
                            onClick={() => handleTabClick('register')}>
                            Sign up
                        </Link>
                    </div>

                    <form className="form" onSubmit={handleLogin}>
                        <div className='form-wrapper'>
                                <div className="message-group"
                                style={{ backgroundColor: error ? 'rgb(221, 167, 164)' : 'transparent' }}>
                                    <div className="svg-div-first">
                                        <svg style={{ color: error ? 'rgb(213, 129, 161)' : 'transparent' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                                        </svg>
                                    </div>
                                    <p id="messages" className="message">{messages}</p>
                                </div>
                            <div className="form-group form-first">
                                <div className="svg-div">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
                                </svg>
                                </div>
                                <div className="username-form">
                                    <input className='inp-col' type="email" name="username" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                </div>
                            </div>
                            <div className="form-group form-last">
                                <div className="svg-div">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-lock-fill" viewBox="0 0 16 16">
                                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
                                </svg>
                                </div>
                                <div className="email-form">
                                    <input className='inp-col' type="password" name="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                </div>
                            </div>
                            

                            <div className='forgot'>
                                <Link to="/forgot-password" className="forgot-link">Forgot your password?</Link>
                            </div>
                        </div>
                        <div >
                            <div className='button-wrap'>
                                <button className="login-but" type="submit">LOGIN</button>
                            </div>
                        </div>

                    </form>
                </div>    
            </div>
        </div>
    );
};

export default LoginForm;
